import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ShieldCheck, Eye, EyeOff } from "lucide-react";
import { Input } from "@/components/ui/input";
import { adminApi, errMsg } from "@/lib/api";
import { ForgotPassword } from "@/admin/ForgotPassword";

export default function AdminLogin() {
  const nav = useNavigate();
  const location = useLocation();
  const [f, setF] = useState({ email: "", password: "" });
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(location.state?.error || "");
  const [forgot, setForgot] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      const { data } = await adminApi.post("/auth/login", { email: f.email, password: f.password });
      nav("/admin", { replace: true, state: { user: data } });
    } catch (er) { setError(errMsg(er)); } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[#F4F5F5] flex items-center justify-center px-4">
      {forgot ? (
        <div className="bg-white rounded-md border border-stone-200 p-8 w-full max-w-sm" data-testid="admin-forgot-card">
          <img src="/images/logo.jpg" alt="Mukti Fresh Vegetable" className="w-12 h-12 rounded-full object-cover" />
          <ForgotPassword onDone={() => setForgot(false)} />
        </div>
      ) : (
      <form onSubmit={submit} className="bg-white rounded-md border border-stone-200 p-8 w-full max-w-sm" data-testid="admin-login-card">
        <div className="flex items-center gap-3 mb-4">
          <img src="/images/logo.jpg" alt="Mukti Fresh Vegetable" className="w-12 h-12 rounded-full object-cover" />
          <ShieldCheck className="w-6 h-6 text-primary" strokeWidth={1.5} />
        </div>
        <h1 className="font-display text-3xl text-primary font-semibold">Mukti Fresh Admin</h1>
        <p className="text-sm text-stone-500 mt-1">Sign in with your admin email and password.</p>
        {error && <p className="mt-4 text-sm text-accent bg-accent/10 rounded-md p-3" data-testid="admin-login-error">{error}</p>}
        <label className="block text-xs font-bold uppercase tracking-wider text-stone-500 mt-5 mb-1">Email</label>
        <Input type="email" autoComplete="username" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} className="h-11" data-testid="admin-login-email" />
        <label className="block text-xs font-bold uppercase tracking-wider text-stone-500 mt-4 mb-1">Password</label>
        <div className="relative">
          <Input type={show ? "text" : "password"} autoComplete="current-password" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} className="h-11 pr-10" data-testid="admin-login-password" />
          <button type="button" onClick={() => setShow(!show)} className="absolute right-2 top-1/2 -translate-y-1/2 p-1 text-stone-500" aria-label="Show password" data-testid="admin-login-toggle-password">
            {show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
          </button>
        </div>
        <button disabled={busy || !f.email || !f.password} className="mt-6 w-full h-11 rounded-md bg-primary text-white font-semibold hover:bg-primary/90 disabled:opacity-50 transition-colors" data-testid="admin-login-submit">
          {busy ? "Signing in…" : "Sign in"}
        </button>
        <button type="button" onClick={() => { setForgot(true); setError(""); }} className="mt-4 text-sm text-primary hover:underline" data-testid="admin-forgot-link">Forgot password?</button>
      </form>
      )}
    </div>
  );
}
